/** 
 * Copyright (c) INOVUA SOFTWARE TECHNOLOGIES.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icons = require("./Icons");

var ClearButton = function ClearButton(_ref) {
  var onClear = _ref.onClear,
      className = _ref.className,
      closeIcon = _ref.closeIcon,
      size = _ref.size;
  var closeIconProps = {
    className: className,
    size: size,
    onClick: function onClick(event) {
      event.preventDefault();
      event.stopPropagation();
      onClear();
    }
  };
  var closeIconEl;

  if (closeIcon && closeIcon !== true) {
    var closeIconParams = {
      onClear: onClear,
      domProps: closeIconProps
    };
    closeIconEl = typeof closeIcon === 'function' ? closeIcon(closeIconParams) : closeIcon;
  }

  if (closeIconEl === undefined) {
    closeIconEl = _react.default.createElement(_Icons.CloseIcon, closeIconProps);
  }

  return closeIconEl;
};

ClearButton.defaultProps = {
  size: 10
};
var _default = ClearButton;
exports.default = _default;